/**
* @author XuZiYu
* @date 2019/9/4
* @time 11:40
*/
<template>
  <div>
    <notOpen v-if="flag === 2" :vipData="vipData.examVipSettingDTO" :uploadAppFlag="vipData.uploadAppFlag"  @refresh="getVipData" :userInfo="userInfo"/>
    <open v-if="flag === 1" :vipData="vipData.examIsVipPageDataDTO" :userInfo="userInfo"/>
  </div>
</template>

<script>
import notOpen from './notOpen'
import open from './open'
import { Toast } from 'vant'
export default {
    name: 'index',
    data () {
        return {
            vipData: {},
            flag: '',
            userInfo: {}
        }
    },
    watch: {
        flag () {
            document.body.scrollTop = 0
        }
    },
    components: {
        notOpen: notOpen,
        open: open
    },
    methods: {
        getVipData () {
            let data = {}
            if (window.app.getAppVersion) {
                data.version = window.app.getAppVersion()
            }
            this.$api.getVipMatchEntry(data).then(res => {
                if (res.status) {
                    this.vipData = res.result
                    this.flag = res.result.vipFlag ? 1 : 2
                } else {
                    Toast.fail(res.message)
                }
            })
        }
    },
    created () {
        window.route = this.$router
        if (window.app.passUserInfo) {
            this.userInfo = window.app.passUserInfo() ? JSON.parse(window.app.passUserInfo()) : {}
        }
        this.getVipData()
    }
}
</script>

<style scoped>

</style>
